import PageWrapper from "../components/UI/PageWrapper";
//import DistributionForm from "../components/Distribution/DistributionForm";

const DistributionPage = () => (
  <PageWrapper>
    <div className="mx-auto p-12 text-white rounded-lg profile-form flex flex-col gap-[2.875rem] min-h-screen">
      <h1 className="profile-info-text-size">Distribution</h1>
    </div>
  </PageWrapper>
);

export default DistributionPage;